const contractAddress = "0x96c71c194a05f3322988b34d9854356a58146539" // ETH NFT

export default contractAddress
